import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { CreateFAQ } from "../content-management/pages/faq/CreateFAQ";
import { FAQsPage } from "../content-management/pages/faq/FAQsPage";
import { UpdateFAQ } from "../content-management/pages/faq/UpdateFAQ";
import { CategoriesPage } from "./pages/Category/CategoriesPage";
import { CreateCategory } from "./pages/Category/CreateCategory";
import { UpdateCategory } from "./pages/Category/UpdateCategory";
import { CreatePost } from "./pages/Post/CreatePost";
import { PostEditContent } from "./pages/Post/PostEditContent";
import { PostsPage } from "./pages/Post/PostsPage";
import { UpdatePost } from "./pages/Post/UpdatePost";
import { CreateTag } from "./pages/Tag/CreateTag";
import { TagsPage } from "./pages/Tag/TagsPage";
import { UpdateTag } from "./pages/Tag/UpdateTag";

export const PostManagementPage = () => {
	return (
		<Routes>
			{/* begin::CATEGORY ROUTES */}
			<Route
				path="categories"
				element={
					<>
						<PageTitle>Categories</PageTitle>
						<CategoriesPage />
					</>
				}
			/>
			<Route
				path="categories/create"
				element={
					<>
						<PageTitle>Categories</PageTitle>
						<CreateCategory />
					</>
				}
			/>
			<Route
				path="categories/:id/update"
				element={
					<>
						<PageTitle>Categories</PageTitle>
						<UpdateCategory />
					</>
				}
			/>
			{/* end::CATEGORY ROUTES */}

			{/* begin::TAG ROUTES */}
			<Route
				path="tags"
				element={
					<>
						<PageTitle>Tags</PageTitle>
						<TagsPage />
					</>
				}
			/>
			<Route
				path="tags/create"
				element={
					<>
						<PageTitle>Tags</PageTitle>
						<CreateTag />
					</>
				}
			/>
			<Route
				path="tags/:id/update"
				element={
					<>
						<PageTitle>Tags</PageTitle>
						<UpdateTag />
					</>
				}
			/>
			{/* end::TAG ROUTES */}

			{/* begin::POST ROUTES */}
			<Route
				path="posts"
				element={
					<>
						<PageTitle>Posts</PageTitle>
						<PostsPage />
					</>
				}
			/>
			<Route
				path="posts/create"
				element={
					<>
						<PageTitle>Posts</PageTitle>
						<CreatePost />
					</>
				}
			/>
			<Route
				path="posts/:id/update"
				element={
					<>
						<PageTitle>Posts</PageTitle>
						<UpdatePost />
					</>
				}
			/>
			<Route
				path="posts/:id/edit-content"
				element={
					<>
						<PageTitle>Posts</PageTitle>
						<PostEditContent />
					</>
				}
			/>
			{/* end::POST ROUTES */}

			{/* FAQs */}
			<Route
				path="faqs"
				element={
					<>
						<PageTitle>FAQs</PageTitle>
						<FAQsPage />
					</>
				}
			/>
			<Route
				path="faqs/create"
				element={
					<>
						<PageTitle>FAQs</PageTitle>
						<CreateFAQ cancelUrl={`/post-management/faqs`} />
					</>
				}
			/>
			<Route
				path="faqs/:id/update"
				element={
					<>
						<PageTitle>FAQs</PageTitle>
						<UpdateFAQ cancelUrl={`/post-management/faqs`} />
					</>
				}
			/>
			{/* FAQs */}

			<Route
				index
				element={<Navigate to="/post-management/posts" replace />}
			/>
			<Route
				path="*"
				element={<Navigate to="/post-management/posts" replace />}
			/>
		</Routes>
	);
};
